<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Service stages') }}</Tab>
                <Tab value="2">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="service_name"
                                       label="Service name"
                                       validation="required"
                                       size="8"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.service_name" />

                        <FormInputText fieldName="symbol"
                                       label="Symbol"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.symbol" />

                        <FormRadioButton fieldName="type"
                                         label="Type"
                                         validation="required"
                                         size="2"
                                         :isFormDisabled="isFormDisabled"
                                         :data="select?.service_types"
                                         v-model:field="crud.type" />

                    </div>

                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                </TabPanel>

                <TabPanel value="1">
                    <div class="grid">
                        <FormRepeaterTable v-model:record="crud.service_stages"
                                           :keys="{ 'stage_id': null, 'order': null, 'description': null }"
                                           :isFirstRowEmpty="false"
                                           :isCopyButton="false"
                                           repeaterStyle="margin-top:5px;width:95%"
                                           name="service_stages"
                                           :title="[__('Stage'), __('Order'), __('Description')]">
                            <template #repeat="slotProps">
                                <td style="width:25%;"
                                    :style="slotProps.cellStyle">
                                    <FormSelect fieldName="stage_id"
                                                :inRepeater="true"
                                                :options="select?.stages"
                                                v-model:field="slotProps.record.stage_id" />
                                </td>
                                <td style="width:15%;"
                                    :style="slotProps.cellStyle">
                                    <FormInputNumber fieldName="order"
                                                     :inRepeater="true"
                                                     v-model:field="slotProps.record.order" />
                                </td>
                                <td style="width:60%"
                                    :style="slotProps.cellStyle">
                                    <FormTextarea fieldName="description"
                                                  :inRepeater="true"
                                                  :rows="2"
                                                  v-model:field="slotProps.record.description" />
                                </td>
                            </template>
                        </FormRepeaterTable>

                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="2"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>
        <AlertAdd :formProps="{ source_table: 'services', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormRadioButton from '@crud/FormRadioButton.vue'
import FormRepeaterTable from '@crud/FormRepeaterTable.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import CustomButton from '@crud/CustomButton.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})

const options = ['service_types', 'stages'];
const select = ref(null);
const isAddAlertDialogOpen = ref(false);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select)
    if (props.formProps.addMode) {
        crud.value.type = select.value?.service_types[0]?.value || null;
        //crud.value.stage_id = select.value?.stages[0]?.value || null;
    }
})

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
